import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchReportByCustomer_api = async (
    customerId: number | string = 0,
    startDate: string = "",
    endDate: string = "",
    inquiryNumber: string = "",
    engineNumber: string = "",
    chassisNumber: string = "",
) => {
    try {
        const response = await axios.get(
            `${SERVER_API}/Reports/fetch_report_by_customer.php`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                params: {
                    customerId,
                    startDate,
                    endDate,
                    inquiryNumber,
                    engineNumber,
                    chassisNumber,
                },
            }
        );

        return response.data;
    } catch (error: any) {
        console.error("Fetch report by customer failed:", error);
        return { error: "Fetch report by customer failed" };
    }
};